<template>
  <div>
    <Header></Header>
    <section class="top">
        <div>
          <h1>泛物网络</h1>
          <p>根据客户续修扩展平台框架,拥有强大的设备连接，数据采集和大数据<br>
          分析能力,助力工业企业数字化转型
          </p>
        </div>
    </section>
<!--  <div class="Anchor" :class="policy==1?'Anchortop':''">
    <div class="within">
      <el-row>
        <el-col :span="6">
          <img src="http://www.ibiandan.cn/img/bdkj01.png" alt="">
          <div>平台优势</div>
        </el-col>
        <el-col :span="6">
          <img src="http://www.ibiandan.cn/img/bdkj01.png" alt="">
          <div>平台优势</div>
        </el-col>
        <el-col :span="6">
          <img src="http://www.ibiandan.cn/img/bdkj01.png" alt="">
          <div>平台优势</div>
        </el-col>
        <el-col :span="6">
          <img src="http://www.ibiandan.cn/img/bdkj01.png" alt="">
          <div>平台优势</div>
        </el-col>
      </el-row>
    </div>

      </div> -->
    <div class="contentds">
        <el-row>
          <el-col :span="17">
            <div class="introduce">
              <div class="title">平台优势</div>
              <p class="text"><span>高共享性：</span>使用功能模块化设计、分层设计实现系统的通用性，模块化平台共享资源、快速部署；</p>
              <p class="text"><span>高并发能力：</span>可快速接入海量设备系统安全运行；</p>
              <p class="text"><span>高智能性：</span>集成AI大数据管理实现用户画像分析实现用户能耗分析；</p>
              <p class="text"><span>高开发性：</span>开放技术结构满足各地需求支持平台快速升级；</p>
              <p class="text"><span>高可靠性：</span>支持大规模分布式部署，千万级设备连接和数十万级 QPS 请求处理能力，毫秒级延迟，可支撑海量物联网设备接入需求；</p>
              <p class="text"><span>数据持久化和实时分析：</span>内置高性能分布式时序数据库，支持海量数据的持久化和实时分析，也支持与用户提供的数据库、大数据平台或消息列对接，方便用户对数据进行存储与消费；</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="img-circle">
              <img src="../../static/img/iotos.png" alt="">
            </div>
          </el-col>
        </el-row>
        <div class="xian"><div></div></div>
        <el-row>
          <el-col :span="7">
            <div class="img-circle">
              <img src="../../static/img/sbgl.jpg" alt="">
            </div>
          </el-col>
          <el-col :span="17" style="padding-left: 60px;">
            <div class="introduce">
              <div class="title">设备管理</div>
              <p class="text"><span>设备台账：</span>设备信息电子化、系统化，形成设备信息库；</p>
              <p class="text"><span>设备运维：</span>智能设备实时监测，掌握设备实时运行状态；</p>
              <p class="text"><span>设备物联：</span>工业设备接入工业云平台，实现数据远程传输，支持设备远程管理；</p>
              <p class="text"><span>设备OEE：</span>围绕企业生产、设备、质量、物流、能环各个环节，实现生产自动化、网络化协同化、决策智能化；</p>
              <p class="text"><span>知识库：</span>设备基本信息、故障信息、维修信息等系统可调取，无需再手动输入。</p>
            </div>
          </el-col>
        </el-row>
        <div class="xian"><div></div></div>
        <el-row>
          <el-col :span="17">
            <div class="introduce">
              <div class="title">可视化展示</div>
              <p class="text">根据用户整体态势监测，数据分析判断多场景业务需求，以多种图标形式展现数据；</p>
              <p class="text">通过对设备上报的大量数据根据业务场景进行实时计算分析，可以抽取整合出想要的业务信息，比如最近10分钟电量；</p>
              <p class="text">质量监测智能化，智能完成经验性判断分析及规则繁琐工作，显著提高质量监测效率及质量，减少人工成本；</p>
              <p class="text">实时监测电压、电流、企业用电量等数据，实时上传至能源管理模块；监控高压配电设备运行状态，实时监控设备消耗电量和历史数据查询。</p>
              <p class="text">涵盖地理位置展示、设备数据采集、异常信息警告，电费信息，和管理等多个可视决策页面；</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="img-circle">
              <img src="../../static/img/dpksh.jpg" alt="">
            </div>
          </el-col>
        </el-row>
        <div class="xian"><div></div></div>

        <el-row>
          <el-col :span="7">
            <div class="img-circle">
              <img src="../../static/img/sjfx.jpg" alt="">
            </div>
          </el-col>
          <el-col :span="17" style="padding-left: 60px;">
            <div class="introduce">
              <div class="title">数据分析</div>
              <p class="text"><span>数据指标：</span>以统一的数据指标系体系链接不同业务，对关键节点的数据进行深度下钻分析，更好地用数据衡量业务效果、洞察业务问题。</p>
              <p class="text"><span>多维度：</span>采用多维度、全方位的数据展示分析；并协助客户分析和调整电力使用情况。</p>
              <p class="text"><span>精准运维：</span>依托大数据分析开展精准运维，实现有周期、有重点的全方位巡视，确保设备运维高质高效，在为用户提供周到的运维服务的同时，充分挖掘与提升产品的售后价值。</p>
              <p class="text"><span>阶段性分析：</span>客户可以针对不同时段，来监控电量的成交金额。并用扇形图直观的展现出尖峰、高峰、平段、谷段四个时刻电量及所产生费用的占比。提供全方位售电业务信息化支撑，满足客户服务、售电测算、市场营销等售电公司基本业务，售电公司可借助配售电平台快速开展售电及相关业务。</p>
            </div>
          </el-col>
        </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  var heightFlag = false//全局变量
  export default {
    data() {
      return {
        // 判断滚动
        policy:1,
      }
    },
    mounted(){
      if(this.$route.query.tid!=undefined){
        this.clickQuotation(this.$route.query.tid)
      }

      window.addEventListener('scroll', this.getScroll);
    },
    methods: {
      //监听滚动
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(this.scrollTop);
        if(this.scrollTop>=390){
          this.policy = 1
        }else{
          this.policy = 0
        }
      },
      // 锚点定位
      clickQuotation(position) {
        var roll= 0
        if(position==1){
          roll=400
        }else if(position==2){
          roll = 884
        }else if(position==3){
          roll = 1210
        }else if(position==4){
          roll = 1500
        }
        if (this.heightFlag) return
          const orangeHeight = window.pageYOffset//点击事件后，页面移动至页面左上角的距离，现在为0（顶部）；const orangeHeight = window.pageYOffset-100（指距顶部下移100）
          let i = 0
          this.heightFlag = true
          this.interval = setInterval(() => {
          const next = Math.floor(this.heightChange(10 * i, orangeHeight, -orangeHeight, 500))
          if (next <= 0) {
            window.scrollTo(0, roll)//第二个0表示滚动距离
            clearInterval(this.interval)
            this.heightFlag = false
          } else {
            window.scrollTo(0, next)
          }
          i++
        }, 16.7)
      },
      heightChange(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b
        return -c / 2 * (--t * (t - 2) - 1) + b
      }
    }
  }
</script>

<style scoped lang="scss">

  .top {
    height: 460px;
    background-image: url(https://www.longshine.com/upload/img/2018/0712/1531372780190745.jpg);
    background-repeat: no-repeat;
    position: relative;
    div{
      position: absolute;
      left: 18%;
      top: 42%;
      z-index: 99;
      h1 {
        color: #FFFFFF;
        &::before{
          content: '';
          width: 40px;
          height: 4px;
          margin-left: 8px;
          background-color: #FFFFFF;
          position: absolute;
          top: 64px;
          left: 0;
        }
      }
      p{
        margin-top: 38px;
        font-size: 17px;
        color: #FFFFFF;
      }
    }
  }
  // .Anchor{
  //   padding: 50px 0;
  //   background-color: #fff;
  //   border-bottom:2px solid rgba(237, 237, 237, 1);
  //   .within{
  //     max-width: 1440px;
  //     margin:  0 auto;
  //     .el-row .el-col{
  //       text-align: center;
  //       div{
  //         font-size: 22px;
  //         color: #3e3e3e;
  //         font-weight: bold;
  //         cursor: pointer;
  //       }
  //       img{
  //         cursor: pointer;
  //       }
  //     }
  //   }

  // }
  // .Anchortop{
  //   width: 100%;
  //   position: fixed;
  //   padding: 10px 0;
  //   top: 70px;
  //   z-index: 99;
  //   .within{
  //     max-width: 1440px;
  //     margin:  0 auto;
  //     .el-row .el-col{
  //       text-align: center;
  //       div{
  //         font-size: 14px;
  //             display: inline-block;
  //             line-height: 32px;
  //       }
  //       img{
  //         width: 32px;
  //             display: inline-block;
  //             vertical-align: middle;
  //             margin-right: 12px;
  //       }
  //     }
  //   }

  // }
  .contentds{
    font-family: 微软雅黑;
    width: 100%;
    max-width: 1440px;
    padding: 0 20px;
    margin: 20px auto;
    padding: 40px 0;

    .xian{
      div{
        width: 100%;
        border-top: 2px solid rgba(237, 237, 237, 1);
      }
      margin: 50px 0;
    }
    .introduce{
      .title{
        font-size: 24px;
        color: #4b0082;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .text{
            color: #333333;
            font-size: 16px;
            line-height: 2.3;
        span{
          font-weight: bold;
        }
      }
    }
    .img-circle{
      img{
        width: 100%;
        min-height: 220px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Platform.vue